module.exports = __webpack_public_path__ + "static/img/female-bg-es.4aba7268.png";